import * as t from "io-ts"

/** A ts-io value represented the result returned when getting an attachment  */
export const DownloadApiRes = t.type({
    data_b64: t.string,
    filename: t.string,
})

/** A type derived from the DownloadApiRes ts-io value representing an attachment */
export type IDownloadApiRes = t.TypeOf<typeof DownloadApiRes>
